import type { Goal } from "~vue/types/goals";

// Mirrors the API's source=extracted filter (coach_db/goals.py), which groups
// conversation-extracted and assessment-suggested goals into Nadia's suggestions.
export function isSuggestedGoal(goal: Goal): boolean {
    return goal.source === "extracted" || goal.source === "assessment";
}

// Canonical render order: newest first, by the date shown on the goal's card
// (the reference session date for extracted goals, otherwise creation date).
export function sortGoalsByDateDesc(goals: Goal[]): Goal[] {
    return [...goals].sort((a, b) => {
        const aDate = a.reference_session_created_at ?? a.created_at;
        const bDate = b.reference_session_created_at ?? b.created_at;
        return new Date(bDate).getTime() - new Date(aDate).getTime();
    });
}
